export default [{
  name: 'downloads.whitepapers.cryptocurrencyNetwork',
  download: 'https://downloads.skycoin.com/whitepapers/%E5%8A%A0%E5%AF%86%E8%B4%A7%E5%B8%81%E7%BD%91%E7%BB%9C%E5%88%86%E5%B8%83%E5%BC%8F%E5%85%B1%E8%AF%86%E7%AE%97%E6%B3%95%E7%99%BD%E7%9A%AE%E4%B9%A6.pdf',
  filetype: '.pdf',
  filesize: '884kb',
}, {
  name: 'downloads.whitepapers.skyFramework',
  download: 'http://downloads.skycoin.com/whitepapers/sky-an-opinion-dynamics-framework-and-model-for-consensus-over-p2-p-network.pdf',
  filetype: '.pdf',
  filesize: '729kb',
}, {
  name: 'downloads.whitepapers.skyHashConsensus',
  download: 'http://downloads.skycoin.com/whitepapers/sky-hash-an-opinion-dynamics-model-for-hash-consensus-over-p2-p-network.pdf',
  filetype: '.pdf',
  filesize: '215kb',
}, {
  name: 'downloads.whitepapers.skyHash',
  download: 'http://downloads.skycoin.com/whitepapers/sky-hash-a-hash-opinion-dynamics-model.pdf',
  filetype: '.pdf',
  filesize: '29kb',
}, {
  name: 'downloads.whitepapers.sznajd2',
  download: 'http://downloads.skycoin.com/whitepapers/sznajd2-a-community-aware-opinion-dynamics-model.pdf',
  filetype: '.pdf',
  filesize: '467kb',
}, {
  name: 'downloads.whitepapers.distributedAlgorithm',
  download: 'http://downloads.skycoin.com/whitepapers/a-distributed-consensus-algorithm-for-cryptocurrency-networks.pdf',
  filetype: '.pdf',
  filesize: '463kb',
}];



// WEBPACK FOOTER //
// ./src/components/WhitepapersPage/components/Whitepapers/downloads.js